import React, { Fragment } from "react";
import { Header, Label, Segment } from "semantic-ui-react";

const SubFlows = () => {
  return (
    <Fragment>
      <Segment raised>
        <Label as="a" color="blue" ribbon>
          Coming Soon
        </Label>
        <Header as="h3">Sub Flows</Header>
        <Header as="h5">Create sub flows to modularise your call flows</Header>
      </Segment>
    </Fragment>
  );
};

export default SubFlows;
